var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article-boxes-container",class:_vm.extraClasses},_vm._l((_vm.articles),function(item){return _c('article-box',{key:item.id,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }